// Demo produkt (ID 7324, kopie WPC proteinu): hlavní fotky 8:5 a fotky variant (soubory 00-main-*) v plném rozlišení z /orig/.
// Shoptet je v /big/ vkládá do plátna 1024×1536, takže v rámu 8:5 jsou rozmazané.
function myDemoOrigUrl(url) {
    return url && url.indexOf("00-main") !== -1 ? myImageSize(url, "orig") : url;
}

function myDemoOrigImages() {
    $(".p-main-image").each(function () {
        $(this).attr("href", myDemoOrigUrl($(this).attr("href")));
        $(this).find("img").attr("src", myDemoOrigUrl($(this).find("img").attr("src")));
    });

    $(".p-thumbnails .p-thumbnail").each(function () {
        $(this).attr("href", myDemoOrigUrl($(this).attr("href")));
    });

    $(".mobile-gallery .swiper-slide img").each(function () {
        $(this).attr("src", myDemoOrigUrl($(this).attr("src")));
    });

    $(".mobile-gallery .swiper-slide a").each(function () {
        $(this).attr("href", myDemoOrigUrl($(this).attr("href")));
    });
}

// Body třída id-1662 je kategorie Proteiny (mají ji všechny proteiny) — demo se pozná podle ID produktu
function myIsDemoProduct() {
    var product = typeof getShoptetDataLayer === "function" ? getShoptetDataLayer("product") : null;
    return !!product && product.id === 7324;
}

$(document).ready(function () {
    if (!myIsDemoProduct()) return;

    $("body").addClass("mydemo-product");

    // Mobilní galerii staví product-detail.js ve vlastním ready handleru — počkat, až doběhne
    $(function () {
        myDemoOrigImages();
    });

    shoptet.scripts.setCustomCallback("shoptet.products.replaceImage", function () {
        myDemoOrigImages();
    });
});
